import { render, staticRenderFns } from "./rightcontain.vue?vue&type=template&id=1929db4c&scoped=true"
import script from "./rightcontain.vue?vue&type=script&lang=js"
export * from "./rightcontain.vue?vue&type=script&lang=js"
import style0 from "./rightcontain.vue?vue&type=style&index=0&id=1929db4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929db4c",
  null
  
)

export default component.exports